<div class="flex flex-col gap-6 p-6">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="textTabsColor text-2xl font-bold" i18n="@@breadcrumbPaymentRequests">طلبات الدفع</h1>
    </div>

    <button
      type="button"
      (click)="onCreateNewPayment()"
      class="bgPrimaryColor hover:bgHoverPrimaryColor cursor-pointer rounded-lg px-6 py-2.5 text-sm font-medium text-white transition-colors focus:outline-none">
      {{ isArabic() ? " إنشاء طلب دفع" : "Create Payment Request" }}
    </button>
  </div>

  <app-admin-payment-requests-filter
    [filters]="filters()"
    [statusOptions]="statusOptionsForFilter()"
    (applyFilters)="onApplyFilters($event)"
    (resetFilters)="onResetFilters()"
    (toggleSortOrder)="onToggleSortOrder()" />

  <app-payment-requests-table
    [items]="items()"
    [state]="state()"
    [currentPage]="currentPage()"
    [itemsPerPage]="itemsPerPage()"
    [totalItems]="totalItems()"
    [totalPages]="totalPages()"
    [isFiltersApplied]="isFiltersApplied()"
    (pageChange)="onPageChange($event)"
    (pageSizeChange)="onPageSizeChange($event)"
    (rowClick)="onRowClick($event)"
    (actionTrigger)="onActionTrigger($event)" />
</div>

<app-request-modification-popup
  [isOpen]="isRequestModOpen()"
  [requestId]="selectedRequestId()"
  [isArabic]="isArabic()"
  (close)="isRequestModOpen.set(false)"
  (successOutput)="onModalSuccess()" />

@if (showRejectPopup()) {
  <app-order-action-popup
    type="reject"
    [title]="isArabic() ? 'رفض طلب الدفع' : 'Reject Payment Request'"
    [description]="
      isArabic()
        ? 'هل أنت متأكد من رفض طلب الدفع؟ إذا كانت المشكلة تتعلق ببيانات ناقصة أو غير صحيحة، يُفضل طلب تعديل بدلاً من الرفض.'
        : 'Are you sure you want to reject this payment request? If the request only contains missing or incorrect information, it is recommended to request a modification instead.'
    "
    [label]="isArabic() ? 'سبب الرفض' : 'Rejection Reason'"
    [submitBtnContent]="isArabic() ? 'رفض' : 'Reject'"
    [secondaryBtnContent]="isArabic() ? 'طلب تعديل' : 'Request Modification'"
    [loading]="rejectPopupLoading()"
    [err]="rejectErr()"
    (submit)="onRejectConfirmed($event)"
    (requestModification)="onRequestModificationConfirmed($event)"
    (closePopup)="onRejectPopupClose()" />
}

@if (showApprovePopup()) {
  <app-order-action-popup
    type="approve"
    [title]="isArabic() ? 'اعتماد طلب الدفع' : 'Approve Payment Request'"
    [description]="
      isArabic() ? 'هل أنت متأكد من اعتماد طلب الدفع؟' : 'Are you sure you want to approve this payment request?'
    "
    [label]="isArabic() ? 'ملاحظات' : 'Comments'"
    [submitBtnContent]="isArabic() ? 'اعتماد' : 'Approve'"
    [loading]="approvePopupLoading()"
    [err]="approveErr()"
    (submit)="onApproveConfirmed($event)"
    (closePopup)="onApprovePopupClose()" />
}

  @if (showCancelPopup()) {
    <app-order-action-popup
      type="approve"
      [title]="isArabic() ? 'إلغاء طلب الدفع' : 'Cancel Payment Request'"
      [description]="
        isArabic()
          ? 'هل أنت متأكد من إلغاء طلب الدفع (رقم الطلب: ' +
            cancelPopupEntity()?.id +
            ')؟ لا يمكن التراجع عن هذا الإجراء.'
          : 'Are you sure you want to cancel payment request (Request ID: ' +
            cancelPopupEntity()?.id +
            ')? This action cannot be undone.'
      "
      [label]="isArabic() ? 'ملاحظات' : 'Comments'"
      [submitBtnContent]="isArabic() ? 'تأكيد' : 'Confirm'"
      [loading]="cancelPopupLoading()"
      [err]="cancelErr()"
      (submit)="onCancelConfirmed($event)"
      (closePopup)="onCancelPopupClose()" />
  }
  @if (rejectSuccess()) {
    <app-successful-notification
      type="success"
      [title]="isArabic() ? 'تم رفض طلب الدفع بنجاح.' : 'Payment request has been rejected successfully.'"
    />
  }
  @if (cancelSuccess()) {
    <app-successful-notification
      type="success"
      [title]="
        isArabic()
          ? 'تم إلغاء طلب الدفع (رقم الطلب: ' + cancelledRequestId() + ') بنجاح.'
          : 'Payment request (Request ID: ' + cancelledRequestId() + ') has been cancelled successfully.'
      "
    />
  }
